import { client } from "api";
import { UserRole } from "features/auth/types/user";

export type ApproveUserRequest = {
  userId: string;
  role: UserRole;
  companyId: string | null;
};

export type ApproveUserResponse = string;

export const approveUser = ({
  userId,
  ...request
}: ApproveUserRequest): Promise<ApproveUserResponse> =>
  client.post<ApproveUserResponse>(`/user/approve/${userId}`, request).then((res) => res.data);
